// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

// 设置rem
function setRem() {
  var deviceWidth = document.documentElement.clientWidth;
  if (deviceWidth > 750) {
    deviceWidth = 7.5 * 50;
  }

  document.documentElement.style.fontSize = deviceWidth / 7.5 + "px";

  var lastTouchEnd = 0;
  document.documentElement.addEventListener(
    "touchend",
    function(event) {
      var now = Date.now();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );

  if (document.getElementsByTagName("meta")["viewport"]) {
    document.getElementsByTagName("meta")["viewport"].content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0";
  } else {
    var meta = document.createElement("meta");
    meta.content =
      "width=device-width, initial-scale=1.0, maximum-scale=1.0,minimum-scale=1.0, user-scalable=0";
    meta.name = "viewport";
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
}

setRem()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js